
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getCity, getTicketList } from '@/api/xiecheng'
import { PROD_LIST_ITEM } from '@/api/xiecheng-api'
import { formatDate } from '@/utils/tool'
import ListItem from './components/ListItem/index.vue'
@Component({
  name: 'ticketList',
  components: {
    ListItem
  }
})
export default class ticketList extends Vue {
  private loading = true // 设置为true是为了先展示骨架屏
  private cityName = ''
  // 国家(城市)列表数据
  private showCity = false // 城市弹窗显示
  private cityList: any[] = []
  private key = ''
  private minPrice = ''
  private maxPrice = ''
  private prodList = [] as Array<PROD_LIST_ITEM> // 产品列表
  private startDay = formatDate(+new Date(), 'Y-M-D') // 开始日期
  private endDay = formatDate(+new Date() + 24 * 60 * 60 * 1000, 'Y-M-D') // 结束日期
  private checkboxSel = null // 已选价格范围
  private noLimit = true // 不限
  private priceList = [
    {
      value: '0-300',
      name: '300以下'
    },
    {
      value: '300-500',
      name: '300 ~ 500'
    },
    {
      value: '500-800',
      name: '500 ~ 800'
    },
    {
      value: '800-1200',
      name: '800 ~ 1200'
    }
  ]

  // 分页
  private page = 1
  private resultNum = 6
  private sizeAll = 0
  // page 改变时会触发
  private currentChange (e: number): void {
    this.page = e
    this.prodList = []
    this.handleList()
  }

  @Watch('$route')
  infoIdChange (newValue: any): void {
    if (newValue && newValue.query.key) {
      this.key = newValue.query.key
      this.reSetList()
    }
  }

  // 获取城市列表
  handeleCity () {
    getCity().then(res => {
      if (res) {
        this.cityList = res.results
        this.cityList.unshift({ supplierViewCity: '全部' })
      }
    })
  }

  // 产品列表
  handleList () {
    this.loading = true
    const params = {
      // edate: this.endDay,
      pageNo: this.page.toString(),
      pageSize: this.resultNum.toString(),
      // sdate: this.startDay,
      cityName: this.cityName === '全部' ? '' : this.cityName,
      keyWord: this.key,
      maxPrice: this.maxPrice.toString(),
      minPrice: this.minPrice.toString()
    }
    getTicketList(params)
      .then(res => {
        this.loading = false
        if (res.success && res.ticketList) {
          this.sizeAll = res.totalCount
          this.prodList = res.ticketList || []
        } else {
          console.error(res.msg)
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  selectCity (name: string) {
    this.cityName = name
    this.showCity = false
    this.noLimit = true
    this.checkboxSel = null
    this.maxPrice = ''
    this.minPrice = ''
    this.reSetList()
  }

  changeRadio (value: string) {
    this.noLimit = false
    this.minPrice = value.split('-')[0]
    this.maxPrice = value.split('-')[1]
    this.reSetList()
  }

  changeRange (type?: string) {
    if (type === 'clear') {
      this.checkboxSel = null
      this.noLimit = true
      this.minPrice = ''
      this.maxPrice = ''
    } else {
      this.checkboxSel = null
      this.noLimit = false
    }
    this.reSetList()
  }

  reSetList () {
    this.page = 1
    this.prodList = []
    this.handleList()
  }

  // 跳转到门票详情
  private goToDetail (id) {
    const queryParams = new URLSearchParams({
      infoId: id
    })
    const url = `/ticketDetail?${queryParams.toString()}`
    this.$router.push(url)
  }

  mounted () {
    const { key } = this.$route.query
    if (typeof key === 'string') this.key = key
    this.handeleCity()
    this.handleList()
  }
}
